import React from "react"

import {
  Wrapper,
  Title,
  Carousel,
  Slider,
  SlideWrapper,
  Slide,
  SlideTextWrapper,
  SlideTitle,
  SlideText,
  SlideMetaData,
  ImageCropped,
  ArrowLeft,
  ArrowRight,
  DotWrapper,
  StyledDot,
} from "./styles"

const Gallery = ({ element }) => {
  const count = element.slides.length

  const formatCreditSource = (credit, source) =>
    credit ? `Image by ${credit}${source ? ` / ${source}` : ""}` : ""

  const imageSizes = {
    1024: [900, 506],
    768: [623, 350],
    0: [480, 270],
  }

  return (
    <Wrapper>
      <Title dangerouslySetInnerHTML={{ __html: element.title }} />
      <Carousel
        id={`mbg-${element.anchor}`}
        naturalSlideWidth={1}
        naturalSlideHeight={1.25}
        totalSlides={count}
        infinite
      >
        <Slider>
          {element.slides.map((slide, idx) => (
            <SlideWrapper key={slide.image.id}>
              <Slide index={idx}>
                <ImageCropped
                  fetchpriority="low"
                  imageData={slide.image}
                  sizes={[
                    {
                      query: 1024,
                      width: imageSizes[1024][0],
                      height: imageSizes[1024][1],
                      transforms: `c_pad,w_${imageSizes[1024][0]},h_${imageSizes[1024][1]},q_auto,f_auto,fl_lossy`,
                    },
                    {
                      query: 768,
                      width: imageSizes[768][0],
                      height: imageSizes[768][1],
                      transforms: `c_pad,w_${imageSizes[768][0]},h_${imageSizes[768][1]},q_auto,f_auto,fl_lossy`,
                    },
                    {
                      width: imageSizes[0][0],
                      height: imageSizes[0][1],
                      transforms: `c_pad,w_${imageSizes[0][0]},h_${imageSizes[0][1]},q_auto,f_auto,fl_lossy`,
                    },
                  ]}
                  alt={slide.image.altText}
                  contain
                />
                <SlideTextWrapper>
                  <SlideTitle dangerouslySetInnerHTML={{ __html: slide.title }} />
                  <SlideText dangerouslySetInnerHTML={{ __html: slide.text }} />
                  <SlideMetaData>
                    {idx + 1} / {count} {formatCreditSource(slide.image.credit, slide.image.source)}
                  </SlideMetaData>
                </SlideTextWrapper>
              </Slide>
            </SlideWrapper>
          ))}
        </Slider>
        <ArrowLeft />
        <ArrowRight />
        <DotWrapper>
          {element.slides.map((slide, idx) => (
            <StyledDot key={slide.image.id} slide={idx} />
          ))}
        </DotWrapper>
      </Carousel>
    </Wrapper>
  )
}

export default Gallery
